import type {
  CategoryResponse,
  CreateCategoryInput,
  PaginatedCategoryResponse,
  UpdateCategoryInput,
  CategorySortBy,
} from '@satyanand/shared'
import { apiRequest } from '@/lib/api'
import { buildQueryString } from '@/lib/domain/query'

type ListCategoryParams = {
  page?: number
  pageSize?: number
  sortBy?: CategorySortBy
  sortDir?: 'asc' | 'desc'
}

function buildQuery(params: ListCategoryParams = {}) {
  return buildQueryString({
    page: params.page ?? 1,
    pageSize: params.pageSize ?? 50,
    sortBy: params.sortBy ?? 'name_en',
    sortDir: params.sortDir ?? 'asc',
  })
}

export async function listAdminCategories(params: ListCategoryParams = {}) {
  return apiRequest<PaginatedCategoryResponse>(
    `/admin/categories?${buildQuery(params)}`,
  )
}

export async function createAdminCategory(input: CreateCategoryInput) {
  return apiRequest<CategoryResponse>('/admin/categories', {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

export async function updateAdminCategory(
  id: string,
  input: UpdateCategoryInput,
) {
  return apiRequest<CategoryResponse>(`/admin/categories/${id}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  })
}

export async function deleteAdminCategory(id: string) {
  return apiRequest<null>(`/admin/categories/${id}`, {
    method: 'DELETE',
  })
}
